import { render } from "./SottostatiTimeline.vue?vue&type=template&id=3f331c4a&scoped=true"
import script from "./SottostatiTimeline.vue?vue&type=script&lang=js"
export * from "./SottostatiTimeline.vue?vue&type=script&lang=js"

import "./SottostatiTimeline.vue?vue&type=style&index=0&id=3f331c4a&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f331c4a"]])

export default __exports__